export default __webpack_public_path__ + "static/shopify-0191bdc77637248c20c420b1cb76dc35.png";